import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/搞笑', label: '分类浏览' },
    { to: '/article/1', label: '资讯动态' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${isScrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              红桃视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? 'text-primary-500'
                    : isScrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`px-5 py-2 text-sm font-medium rounded-full border transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-500'
                : 'border-background-50/50 text-background-50 hover:bg-background-50/10'
            }`}>
              下载App
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isScrolled ? 'text-foreground-950' : 'text-background-50'}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  isActive(link.to) ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button className="mt-2 w-full py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer">
              下载红桃视频App
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}